export var TelemetryExportOtlpProtocol;
(function (TelemetryExportOtlpProtocol) {
    TelemetryExportOtlpProtocol["TELEMETRY_EXPORT_OTLP_PROTOCOL_HTTP"] = "OTLP_HTTP";
})(TelemetryExportOtlpProtocol || (TelemetryExportOtlpProtocol = {}));
